export default {
    namespaced: true,
    state: {
		endpoint: 'realty/operation/type',
		item: {},
        items: [],
    },
}